export const StageContexts = {
    Interaction: 'Interaction',
    Breakpoint: 'Breakpoint',
};
export const InteractionContexts = {
    hover: 'hover',
};
//# sourceMappingURL=contexts.js.map